import { useEffect, useState } from "react";
import { ArquivosCotaUsuario } from "../../../interfaces/ArquivosCotaUsuario";
import { buscarArquivosCotaUsuarioByIdService } from "../../../services/buscarArquivosCotaUsuarioByIdService";
import { formatDate } from "../../../uteis/dateUtils";

export const useArquivos = (cotaUsuarioId: number | null | undefined) => {
  const [arquivos, setArquivos] = useState<ArquivosCotaUsuario[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = async () => {
    if (cotaUsuarioId) {
      setIsLoading(true);
      try {
        const data = await buscarArquivosCotaUsuarioByIdService(cotaUsuarioId);
        if (data) {
          const arquivosData = data.map((arquivo: any) => {
            arquivo.id = arquivo.id;
            arquivo.key = arquivo.id;
            if (arquivo.ArquivoTable.mimetype) {
              switch (arquivo.ArquivoTable.mimetype) {
                case "application/pdf":
                  arquivo.tipo = "PDF";
                  break;
                case "application/msword":
                  arquivo.tipo = "WORD";
                  break;
                case "image/jpeg":
                  arquivo.tipo = "JPEG";
                  break;
                case "image/png":
                  arquivo.tipo = "PNG";
                  break;
                case "video/mp4":
                  arquivo.tipo = "MP4";
                  break;
                case "application/vnd.ms-excel":
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                  arquivo.tipo = "EXCEL";
                  break;
                default:
                  arquivo.tipo = "NEUTRO";
              }
            }
            arquivo.nomeArquivo = arquivo.ArquivoTable.filename;
            arquivo.nome = arquivo.ArquivoTable.originalname;
            const tamanhoPreparado = Math.round(
              arquivo.ArquivoTable.size / 1000
            );
            arquivo.arquivoId = arquivo.ArquivoTable.id;
            arquivo.tamanho =
              tamanhoPreparado > 1000
                ? `${Math.round(tamanhoPreparado / 1000)} MB`
                : `${tamanhoPreparado} KB`;
            arquivo.data_inclusao = formatDate(arquivo.created_at);
            return arquivo;
          });
          setArquivos(arquivosData);
        } else {
          console.error("Dados não encontrados");
        }
      } catch (error) {
        console.error("Erro ao buscar Arquivos:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [cotaUsuarioId]);

  return { fetch, arquivos, isLoading };
};
